var map = {
	"./advertorial.svg": 189,
	"./album.svg": 190,
	"./analysis.svg": 191,
	"./anchor.svg": 192,
	"./android-block.svg": 193,
	"./android-small.svg": 194,
	"./android.svg": 195,
	"./angle-down.svg": 196,
	"./angle-left.svg": 197,
	"./angle-right.svg": 198,
	"./angle-up.svg": 199,
	"./aquarius.svg": 200,
	"./aries.svg": 201,
	"./arrow-down.svg": 202,
	"./arrow-left.svg": 203,
	"./arrow-right.svg": 204,
	"./arrow-up.svg": 205,
	"./arrow.svg": 206,
	"./art-director.svg": 207,
	"./author.svg": 208,
	"./authoranchor.svg": 209,
	"./automobile.svg": 210,
	"./bookmark.svg": 211,
	"./brandconnect.svg": 212,
	"./breaking-news.svg": 213,
	"./bullet-arrow.svg": 214,
	"./bundle.svg": 215,
	"./business.svg": 216,
	"./calendar.svg": 217,
	"./cancel.svg": 218,
	"./cancer.svg": 219,
	"./canvas.svg": 220,
	"./capricorn.svg": 221,
	"./cartoonist.svg": 222,
	"./cinema.svg": 223,
	"./clapboard.svg": 224,
	"./clipboard.svg": 225,
	"./close.svg": 226,
	"./comm-album.svg": 227,
	"./comm-automobile.svg": 228,
	"./comm-children.svg": 229,
	"./comm-cinema.svg": 230,
	"./comm-entertainment.svg": 231,
	"./comm-environment.svg": 232,
	"./comm-finance.svg": 233,
	"./comm-gadgets.svg": 234,
	"./comm-health.svg": 235,
	"./comm-lifestyle.svg": 236,
	"./comm-news.svg": 237,
	"./comm-science.svg": 238,
	"./comm-spiritual.svg": 239,
	"./comm-sports.svg": 240,
	"./comm-technology.svg": 241,
	"./comm-video.svg": 242,
	"./comm-vikatan-plus.svg": 243,
	"./comm-women.svg": 244,
	"./comm-world-cup.svg": 245,
	"./comment.svg": 246,
	"./creative-director.svg": 247,
	"./cricket.svg": 248,
	"./data.svg": 249,
	"./designed.svg": 250,
	"./downarrow.svg": 251,
	"./download.svg": 252,
	"./edited-by.svg": 253,
	"./email.svg": 254,
	"./environment.svg": 255,
	"./exclusivedeals.svg": 256,
	"./facebook-bg.svg": 257,
	"./facebook.svg": 258,
	"./filter-icon.svg": 259,
	"./filter.svg": 260,
	"./food-stylist.svg": 261,
	"./gallery.svg": 262,
	"./gemini.svg": 263,
	"./group.svg": 264,
	"./health.svg": 265,
	"./hexbackground.svg": 266,
	"./illustrator-t1.svg": 267,
	"./illustrator.svg": 268,
	"./infographer.svg": 269,
	"./instagram.svg": 270,
	"./interviews.svg": 271,
	"./ios-block.svg": 272,
	"./ios-small.svg": 273,
	"./ios.svg": 274,
	"./jokes.svg": 275,
	"./leo.svg": 276,
	"./libra.svg": 277,
	"./lifestyle.svg": 278,
	"./line-arrow-next.svg": 279,
	"./line-arrow-prev.svg": 280,
	"./linkedin.svg": 281,
	"./listicle.svg": 282,
	"./live-chat.svg": 283,
	"./liveupdate.svg": 284,
	"./longform.svg": 285,
	"./magazines.svg": 286,
	"./microphone.svg": 287,
	"./minus.svg": 288,
	"./mobile-share.svg": 289,
	"./moderated.svg": 290,
	"./narrated.svg": 291,
	"./news.svg": 292,
	"./newsletter.svg": 293,
	"./newslettericon.svg": 294,
	"./paywalliconbenefit.svg": 295,
	"./paywalliconbenefitfour.svg": 296,
	"./paywalliconbenefitthree.svg": 297,
	"./paywalliconbenefittwo.svg": 298,
	"./pen.svg": 299,
	"./phone.svg": 300,
	"./photo.svg": 301,
	"./photographer.svg": 302,
	"./photostory.svg": 303,
	"./pisces.svg": 304,
	"./plus.svg": 305,
	"./poems.svg": 306,
	"./premium.svg": 307,
	"./producer.svg": 308,
	"./proofread.svg": 309,
	"./published-by.svg": 310,
	"./published.svg": 311,
	"./rss.svg": 312,
	"./rupee.svg": 313,
	"./sagitarius.svg": 314,
	"./scorpio.svg": 315,
	"./script-writer.svg": 316,
	"./scripted.svg": 317,
	"./search.svg": 318,
	"./share-alt.svg": 319,
	"./share.svg": 320,
	"./shortform.svg": 321,
	"./shortstories.svg": 322,
	"./shortvideo.svg": 323,
	"./slider-next.svg": 324,
	"./slider-prev.svg": 325,
	"./socialshare.svg": 326,
	"./sort.svg": 327,
	"./sound.svg": 328,
	"./speaker.svg": 329,
	"./spiritual.svg": 330,
	"./sponsored.svg": 331,
	"./sports.svg": 332,
	"./star.svg": 333,
	"./stories.svg": 334,
	"./stylist.svg": 335,
	"./success-icon.svg": 336,
	"./taurus.svg": 337,
	"./technology.svg": 338,
	"./text.svg": 339,
	"./thump.svg": 340,
	"./trending.svg": 341,
	"./twitter.svg": 342,
	"./uparrow.svg": 343,
	"./user.svg": 344,
	"./video-editor.svg": 345,
	"./video-play.svg": 346,
	"./video.svg": 347,
	"./videographer.svg": 348,
	"./vikatan-tv.svg": 349,
	"./vikatanconnect.svg": 350,
	"./vikatanspl.svg": 351,
	"./vikatantv.svg": 352,
	"./virgo.svg": 353,
	"./whatsapp.svg": 354,
	"./writtenarticles.svg": 355,
	"./writtenstory.svg": 356,
	"./youtube.svg": 357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;